<template>
  <div class="row mt-5">
    <div class="col-sm-12">
      <div v-if="isLoadingHeader" class="row">
        <div class="col-md-12">
          <div style="width: 550px; margin-bottom: 20px">
            <skeleton-loading>
              <skeleton-square
                :box-properties="{
                  top: '10px',
                  height: '25px',
                }"
                :count="1"
              />
            </skeleton-loading>
          </div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-between align-items-center">
        <h1
          v-if="getPublicCourses.total"
          class="allClasses__subtitles mobile-space m-0"
        >
          {{
            `${
              getPublicCourses.total > 1
                ? `${getPublicCourses.total} Cursos`
                : '1 Curso'
            }`
          }}
        </h1>
        <h1 v-else class="allClasses__subtitles mobile-space m-0">Cursos</h1>
      </div>
      <div v-if="isLoading" class="row">
        <skeleton-card-video
          v-for="index in 3"
          :key="index"
          class="col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-4"
        />
      </div>
      <div v-else>
        <div
          v-if="getPublicCourses.items && getPublicCourses.items.length"
          class="row show-in-desktop"
        >
          <card-course
            v-for="course in getPublicCourses.items"
            :key="course.id"
            :data="course"
            class="col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-4"
          />
        </div>
        <div
          v-if="getPublicCourses.items && getPublicCourses.items.length"
          class="col-12 view-home-tabs pl-0 view-tabs-mobile mb-4 show-in-mobile"
        >
          <carousel
            :navigation-enabled="true"
            :per-page="1"
            :per-page-custom="[
              [545, 2],
              [825, 3],
              [1200, 4],
            ]"
            :scroll-per-page="true"
            :speed="500"
            navigation-next-label="<i class='fas fa-chevron-right'></i>"
            navigation-prev-label="<i class='fas fa-chevron-left'></i>"
          >
            <slide
              v-for="course in getPublicCourses.items"
              :key="course.id"
              class="d-flex flex-column"
              style="padding-right: 10px; flex-basis: 300px"
            >
              <card-course style="width: 300px" :data="course" />
            </slide>
          </carousel>
        </div>
        <div v-else class="text-center pt-4">
          <h3>
            No hay cursos relacionados con la busqueda "{{
              this.$route.query.q
            }}"
          </h3>
        </div>
      </div>
      <div v-if="getPublicCourses.items && getPublicCourses.items.length">
        <div
          v-if="totalPages > 1"
          class="pt-4 pb-2 d-flex justify-content-end border-top-0"
        >
          <base-pagination
            :value="page"
            class="pagination-style"
            :page-count="totalPages"
            @input="paginationChange"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonCardVideo from '../../../Components/skeletons/SkeletonCardVideo.vue';
import { FETCH_PUBLIC_COURSES } from '../../../../store/actions/public';
import { mapGetters } from 'vuex';
import CardCourse from '../../Courses/components/CardCourse.vue';
import SkeletonSquare from '../../../../components/Skeleton/components/SkeletonSquare.vue';
import SkeletonLoading from '../../../../components/Skeleton/SkeletonLoading.vue';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'SearchCourses',
  components: {
    SkeletonLoading,
    SkeletonSquare,
    CardCourse,
    SkeletonCardVideo,
    Carousel,
    Slide,
  },
  data() {
    return {
      isLoadingHeader: true,
      isLoading: true,
      perPage: 3,
      page: 1,
    };
  },
  computed: {
    ...mapGetters(['getPublicCourses']),
    totalPages() {
      return Math.ceil(this.getPublicCourses.total / this.perPage);
    },
  },
  watch: {
    $route: async function (to) {
      this.isLoading = true;
      this.isLoadingHeader = true;
      this.fetchCourses({
        search: to.query.q ?? '',
        per_page: this.perPage,
        page: this.page,
        order_by: 'DESC',
      });
    },
  },
  mounted() {
    this.fetchCourses();
  },
  methods: {
    fetchCourses(
      filter = {
        search: this.$route.query.q ?? '',
        per_page: this.perPage,
        page: this.page,
        order_by: 'DESC',
      },
    ) {
      this.$store
        .dispatch(FETCH_PUBLIC_COURSES, filter)
        .then(() => {
          this.isLoading = false;
          this.isLoadingHeader = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    async paginationChange(page) {
      this.page = page;
      this.isLoading = true;
      await this.fetchCourses({
        page,
        per_page: this.perPage,
        order_by: 'DESC',
        search: this.$route.query.q ?? '',
      });
    },
  },
};
</script>

<style>
.md-tabs-navigation .md-button-content {
  color: #fff;
}

.show-in-mobile {
  display: none;
}

@media (max-width: 600px) {
  .show-in-desktop {
    display: none;
  }

  .show-in-mobile {
    display: block;
    padding-top: 10px;
  }
}
</style>
